export const GET_ANIMALS_RECOMENDATION = "GET_ANIMALS_RECOMENDATION";
export const GET_SIMILAR_ENTITIES = "GET_SIMILAR_ENTITIES";
export const ERROR_GET_SIMILAR_ENTITIES = "ERROR_GET_SIMILAR_ENTITIES";


// =========================================================================
//                             GETS ANIMALS
// =========================================================================

// -------------------------
// GENERAL
// -------------------------

export function getAnimalsRecomendation(filter) {
    return (dispatch, getState) => {

        //console.log("actionsRecomendations::getAnimalsRecomendation()");

        //TODO 23/2/22 21:42: apaño temporal para las recomendaciones en base aun animal usando la busqueda
        if (filter.ignoreList && Array.isArray(filter.ignoreList)) {

            filter.ignoreList.push(filter.animal_id)
        } else {
            filter.ignoreList = [filter.animal_id]
        }


        let datos = {...filter}
        datos.num = filter.metadata.num;
        datos.pag = filter.metadata.pag;


        $.ajax({
            //Cambiar a type: POST si necesario
            type: "GET",
            //Datos que se envian
            //data: JSON.stringify(datos),
            data: datos,
            // Formato de datos que se espera en la respuesta
            dataType: "json",
            // URL a la que se enviará la solicitud Ajax
            url: "/api/busqueda/avanzada",
        })
            .done(function (response, textStatus, jqXHR) {
                //console.log(response);

                dispatch({type: GET_ANIMALS_RECOMENDATION, payload: response});
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                let errorStr;
                if (typeof jqXHR.responseJSON === "object" && jqXHR.responseJSON.error !== undefined) {
                    errorStr = jqXHR.responseJSON.error.map(err => err.msg).join(', ').replace(/,(?!.*,)/gmi, ' y')
                } else {
                    errorStr = jqXHR.responseJSON;
                }

                if (console && console.log) {
                    console.log("La solicitud a fallado: " + errorStr);
                }
            });
        // });
    }

}

export function getSimilarEntitiesRecomendation(filter) {
    return (dispatch, getState) => {
        
        //console.log("actionsRecomendations::getAnimalsRecomendation()");
        //TODO 28/12/22 21:42: apaño temporal para las recomendaciones en base aun animal usando la busqueda
        if (filter.ignoreList && Array.isArray(filter.ignoreList)) {

            filter.ignoreList.push(filter.entity_id)
        } else {
            filter.filter.ignoreList = [filter.filter.entity_id]
            filter.filter.entity_id=undefined
        }
        
        
        let datos = {...filter}
        datos.num = filter.metadata.num;
        datos.pag = filter.metadata.pag;
        
        
        $.ajax({
                //Cambiar a type: POST si necesario
                type: "GET",
                //Datos que se envian
                //data: JSON.stringify(datos),
                data: datos,
                // Formato de datos que se espera en la respuesta
                dataType: "json",
                // URL a la que se enviará la solicitud Ajax
                url: "/api/busqueda/entity",
            })
            .done(function (response, textStatus, jqXHR) {
                //console.log(response);
                
                dispatch({type: GET_SIMILAR_ENTITIES, payload: response});
                dispatch({type: ERROR_GET_SIMILAR_ENTITIES, payload: undefined});
    
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                let errorStr;
                if (typeof jqXHR.responseJSON === "object" && jqXHR.responseJSON.error !== undefined) {
                    errorStr = jqXHR.responseJSON.error.map(err => err.msg).join(', ').replace(/,(?!.*,)/gmi, ' y')
                } else {
                    errorStr = jqXHR.responseJSON;
                }
                
                if (console && console.log) {
                    console.log("La solicitud a fallado: " + errorStr);
                }
            });
        // });
    }
    
}


export function resetAnimalsRecomendation() {
    //console.log("actionsRecomendations::resetAnimalsRecomendation()");
    return (dispatch, getState) => {
        dispatch({type: GET_ANIMALS_RECOMENDATION, payload: {}});
    }
}

export function resetSimilarEntitiesRecomendation() {
    //console.log("actionsRecomendations::resetAnimalsRecomendation()");
    return (dispatch, getState) => {
        dispatch({type: GET_SIMILAR_ENTITIES, payload: {}});
    }
}



// **************************CARTAS DETALLES ANIMAL*******************************


